import { TUNER_STEP } from './constants';

export type PowerupType = 'doublejump' | 'armor' | 'jump' | 'dash' | 'run';

/** Active modifiers applied on top of the base movement constants. */
export interface PlayerMods {
  doubleJump: boolean;
  armor: boolean; // a held armor charge (absorbs one hit)
  jumpMult: number;
  dashMult: number;
  runMult: number;
}

export function defaultMods(): PlayerMods {
  return { doubleJump: false, armor: false, jumpMult: 1, dashMult: 1, runMult: 1 };
}

/** Apply a collected power-up, returning new mods (pure). */
export function applyPowerup(mods: PlayerMods, type: PowerupType): PlayerMods {
  switch (type) {
    case 'doublejump':
      return { ...mods, doubleJump: true };
    case 'armor':
      return { ...mods, armor: true };
    case 'jump':
      return { ...mods, jumpMult: mods.jumpMult * TUNER_STEP };
    case 'dash':
      return { ...mods, dashMult: mods.dashMult * TUNER_STEP };
    case 'run':
      return { ...mods, runMult: mods.runMult * TUNER_STEP };
  }
}
